'use strict';

import withQueryClient from "~/helpers/withQueryClient";
import EmptylegsSearchContainer from "~/features/search/containers/EmptylegsSearchContainer";

function EmptylegsSearchWidget(props) {
    return <EmptylegsSearchContainer {...props} />
}

window.EmptylegsSearchWidget = withQueryClient(EmptylegsSearchWidget)
